import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, CancelRounded, CheckCircle, Edit, Sync } from '@mui/icons-material';

import FormikControl from '../../../../../../components/FormikControl/FormikControl';
import voucherServices from '../voucherServices';
import { useAlert } from '../../../../../../context/AlertContext';

import moment from 'moment';
import SelectParty from '../../party/components/SelectParty';
import { useKeyPress } from '../../../../../../hooks/useKeyPress';



function EditVoucherForm({data,callBack }) {

    const {AppAlert} = useAlert();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);
    const [party,setParty] = useState(null);

    const initialValues = {        
        //voucherNo:"",
        refNo:"",
        ewayBillNo:"",
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            //voucherNo:data.voucherNo,
            refNo:data.refNo,
            ewayBillNo:data.ewayBillNo,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        //partyId:Yup.string().required("Required"),
    });

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        let payload = {...values};
        voucherServices.save(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            console.log(error);
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    const synsTaxDetails = () =>{
        setSavingStatus(true);
        voucherServices.syncTaxDetails({partyId:data.partyId,voucherId:data.id}).then(res=>{
            callBack();
        }).catch(error=>{

        }).finally(()=>{
            setSavingStatus(false);
        })
    }
    
    return (
        <>
            {data &&      
                <button className="btn btn-outline-primary me-2" onClick={updateData}>Edit Voucher Details</button>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Voucher"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row">
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Order /Ref Number" name="refNo" 
                                                    />
                                                </div>
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Waybill No" name="ewayBillNo" 
                                                    />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <hr />
                                                <div className='col-md-6'>Party Gstin : <span className='fw-bold'>{data.partyGstin}</span></div>
                                                <div className='col-md-6'>Party Pan : <span className='fw-bold'>{data.partyPan}</span> </div>
                                                <div className='col-md-6'>Registration Type : <span className='fw-bold'>{data.registrationType}</span></div>
                                                <div className='col-md-6'>TDS Applicable : <span className='fw-bold'>{data.tdsApplicable ? <CheckCircle className='text-success'/> : <CancelRounded className='text-danger' /> }</span></div>
                                                <div className='col-md-12'>
                                                    <button className='btn btn-outline-primary float-end' type='button' onClick={synsTaxDetails} > <Sync/> Reload Tax Details</button>
                                                </div>
                                            </div>
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik)  */ }
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default EditVoucherForm